import icons from "../../utils/svgProvider";

export const VARIANT = Object.freeze({
	DRAWER: "drawer",
});

export const HEADER_CONFIG = Object.freeze({
	drawer: {
		classNames: {
			header: "addtocart-drawer__header",
			button: "addtocart-drawer__header--close",
			headingWrapper: "addtocart-drawer__header__wrapper",
			heading: "addtocart-drawer__header__heading",
		},
		icons: {
			checkmark: icons.checkmarkWhite,
			close: icons.closeBig,
		},
	},
});
